module.exports = __webpack_public_path__ + "img/Strip-Front-B3-Jd.7d9681fa.png";